import React from 'react';
import {Button} from "@mui/material";

const OutlinedButton = ({onClick, children}) => {
    return (
      <Button variant="outlined" color="outlinedLight" sx={{ color: 'black' }} onClick={onClick}>
        {children}
      </Button>
    );
};

export default OutlinedButton;